const COIN_INSIGHTS = {
  th: {
    btc: "bitcoin",
    eth: "ethereum",
    c8p: "c8p",
    omg: "omg",
    sxp: "sxp",
    enj: "enj",
    ltc: "litecoin",
    xrp: "ripple",
    bch: "bitcoin-cash",
    comp: "compound",
    gold: "xbullion",
    link: "link",
    mkr: "mkr",
    usdc: "usdc",
    usdt: "usdt",
    yfi: "yfi",
    sand: "sand",
    six: "six",
    xlm: "xlm",
  },
  en: {
    comp: "compound",
    sand: "sand",
  },
};

export const getCoinInsightLink = (lang, slug) => {
  // get coin name from slug
  // e.g. `bitcoin-th` should return `bitcoin`
  const [coinPath] = /.*(?=-)/.exec(slug) || [slug];
  const isEnglish = lang !== "th" && lang !== "id";
  const coinInsightLang = isEnglish ? "en" : lang;

  const { [coinPath]: coinInsightLink } = COIN_INSIGHTS[coinInsightLang] || {};

  return coinInsightLink
    ? `/coin-info/${coinInsightLink}-${coinInsightLang}-coin-insight.pdf`
    : null;
};
